module.exports = __webpack_public_path__ + "img/Andy.bbd61ae3.jpg";